import { SerializableObject } from '../../common-react/core';

export class FamilyMember extends SerializableObject {
  public name: string;
  public identificationNumber: string;
}
